
<template>
    <div>
        <loader :loader="sending" />
        <v-data-table :headers="headers" :items="list" :items-per-page="itemsPerPage"
            no-data-text="Sin resultados disponibles" dense fixed-header hide-default-footer>
            <template v-slot:[`item.registrationDate`]="{ item }">
                {{ $utilFront.formatDateTime(item.registrationDate) }}
            </template>
            <template v-slot:[`item.hasUser`]="{ item }">
                <v-icon color="success" v-if="item.hasUser">mdi-checkbox-blank-circle</v-icon>
                <v-icon color="error" v-if="!item.hasUser">mdi-checkbox-blank-circle</v-icon>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-tooltip top v-if="$utilFront.withPermission($prm.UPDATE_DOCTOR)">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn icon @click="get(item, 3)" dense x-small>
                            <v-icon color="secondary" v-bind="attrs" v-on="on">
                                mdi-pencil
                            </v-icon>
                        </v-btn>
                    </template>
                    <span>Editar</span>
                </v-tooltip>
                <v-tooltip top v-if="item.hasUser && $utilFront.withPermission($prm.RESET_PASSWORD_DOCTOR)">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn icon @click="openDialogRestore(item)" dense x-small class="ml-2">
                            <v-icon color="yellow" v-bind="attrs" v-on="on"> mdi-restart </v-icon>
                        </v-btn>
                    </template>
                    <span>Restaurar contraseña</span>
                </v-tooltip>
                <span v-if="!$utilFront.withPermission($prm.UPDATE_DOCTOR) && ( !$utilFront.withPermission($prm.RESET_PASSWORD_DOCTOR) || !item.hasUser)">
                        - - -
                </span>
                
            </template>
        </v-data-table>
        <v-dialog v-model="dialogRestore" persistent max-width="550">
            <v-card>
                <v-card-title class="text-h6 text-center"> Advertencia </v-card-title>
                <v-card-text>
                    La constraseña se modificará a
                    <span class="font-weight-black"> {{ objRestore.email }}</span>
                    <br />
                    ¿Desea restablece la contraseña para:
                    <span class="font-weight-black">{{ objRestore.fullName }}</span>
                    ?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" text @click="dialogRestore = false">
                        Cancelar
                    </v-btn>
                    <v-btn color="primary" text @click="restorePassword()" :disabled="sending">
                        Aceptar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import MenuCrud from "@/app/components/base/menu/MenuCrud.vue";
import CancelationModal from "@/app/components/common/CancelationModal.vue";
import Loader from "@/app/components/base/loader/Loader.vue";
import DoctorService from "../../services/DoctorService";
import UserRequest from "../../../core/request/UserRequest";

export default {
    name: "DoctorTable",
    props: {
        list: Array,
        get: Function,
        deleteItem: Function,
        updateStatus: Function,
        itemsPerPage: Number,
    },
    components: {
        MenuCrud,
        CancelationModal,
        Loader
    },
    data() {
        return {
            dialogRestore: false,
            idPatient: null,
            appointmentDialog: false,
            dataModal: {},
            dialogCancelation: false,
            sending: false,
            objRestore: {},
            headers: [
                {
                    text: "Id Médico",
                    value: "idDoctor",
                    sortable: false,
                    align: "center",
                    width: "20%",
                },
                {
                    text: "Nombre del médico",
                    value: "fullName",
                    align: "center",
                    sortable: false,
                },
                {
                    text: "Fecha de registro",
                    value: "registrationDate",
                    align: "center",
                    sortable: false,
                    width: "20%",
                },
                {
                    text: "Usuario",
                    value: "hasUser",
                    align: "center",
                    sortable: false,
                    width: "20%",
                },
                {
                    text: "Acciones",
                    value: "actions",
                    sortable: false,
                    align: "center",
                    width: "15%",
                },
            ],
        };
    },
    methods: {
        checkCancel(item) {
            this.dataModal = {};
            this.dataModal = Object.assign(this.dataModal, item);
            this.dataModal.birthDate = this.$utilFront.formatDate(
                this.dataModal.birthDate
            );
            this.dialogCancelation = true;
        },
        closeCancelationDialog(e) {
            this.dialogCancelation = e;
            this.deleteItem();
        },
        openDialogRestore(item) {
            this.sending = true;

            DoctorService.get(item).then((response) => {
                this.objRestore = response.data;
                this.objRestore.email = response.data.contactInformation?.email;
                this.dialogRestore = true;
            }).finally(() => {
                this.sending = false;
            });


        },
        restorePassword() {
            if (!this.sending) {
                this.sending = true;
                let data = { idUser: this.objRestore.user.idUser };
                UserRequest.restorePassword(data).then((res) => {
                    if (res.data.code === 200 && res.data.status === "OK") {
                        this.$utilFront.notifications("Contraseña actualizada correctamente", "SUCCESS");
                    } else {
                        this.$utilFront.notifications("Error al restablecer la contraseña, intente nuevamente", "ERROR");
                    }
                    this.dialogRestore = false;
                }).catch((e) => {
                    this.$utilFront.notifications("Ha ocurrido un error interno", "ERROR");
                }).finally(() => {
                    this.sending = false;
                });
            }
        }
    },
};
</script>
